import { createFileRoute } from "@tanstack/react-router";
import { PharmaPage, pharmaHead } from "@/pages/PharmaPage";

export const Route = createFileRoute("/en/industries/pharma-life-science")({
  head: () => pharmaHead("en"),
  component: () => <PharmaPage locale="en" />,
});
